import { createI18n } from 'vue-i18n'

// Import your language files
import en from './locales/en.json'
import km from './locales/km.json'
import paymentSystemEn from './locales/payment-system.en.json'
import paymentSystemKm from './locales/payment-system.km.json'
import planUsageEn from './locales/plan-usage.en.json'
import planUsageKm from './locales/plan-usage.km.json'
import admissionRefundsEn from './locales/admission-refunds.en.json'
import admissionRefundsKm from './locales/admission-refunds.km.json'
import admissionFeeCancellationEn from './locales/admission-fee-cancellation.en.json'
import admissionFeeCancellationKm from './locales/admission-fee-cancellation.km.json'
import admissionPayWayRefundsEn from './locales/admission-payway-refunds.en.json'
import admissionPayWayRefundsKm from './locales/admission-payway-refunds.km.json'
import analyticsDeliveryEn from './locales/analytics-delivery.en.json'
import analyticsDeliveryKm from './locales/analytics-delivery.km.json'
import admissionQueueEn from './locales/admission-queue.en.json'
import admissionQueueKm from './locales/admission-queue.km.json'
import teacherSessionMarkEn from './locales/teacher-session-mark.en.json'
import teacherSessionMarkKm from './locales/teacher-session-mark.km.json'
import studentTransfersEn from './locales/student-transfers.en.json'
import studentTransfersKm from './locales/student-transfers.km.json'

// Merge payment system translations with main translations
const enMessages = {
    ...en,
    ...paymentSystemEn,
    ...planUsageEn,
    ...admissionRefundsEn,
    ...admissionFeeCancellationEn,
    ...admissionPayWayRefundsEn,
    ...analyticsDeliveryEn,
    ...admissionQueueEn,
    ...teacherSessionMarkEn,
    ...studentTransfersEn,
    payment_system: {
        ...en.payment_system,
        ...paymentSystemEn.payment_system,
    },
}

const kmMessages = {
    ...km,
    ...paymentSystemKm,
    ...planUsageKm,
    ...admissionRefundsKm,
    ...admissionFeeCancellationKm,
    ...admissionPayWayRefundsKm,
    ...analyticsDeliveryKm,
    ...admissionQueueKm,
    ...teacherSessionMarkKm,
    ...studentTransfersKm,
    payment_system: {
        ...km.payment_system,
        ...paymentSystemKm.payment_system,
    },
}

export default createI18n({
    legacy: false, // Set to false to use Composition API
    locale: 'en', // Set default locale
    fallbackLocale: 'en', // Set fallback locale
    messages: {
        en: enMessages,
        km: kmMessages
    },
})
